import { defineComponent as _defineComponent } from 'vue'
import RangeInput from '@/ui-components/RangeInput.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';

import { AppDirection } from '@/enums/app-direction';

import { useI18n } from '@/helpers/composables/useI18n';

import { usePlotRecommenderStore } from './usePlotRecommenderStore';
import { useMetaStore } from '@/stores/pinia/useMetaStore';

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderPriceFilter',
  setup(__props) {

const { tc } = useI18n();

const prStore = usePlotRecommenderStore();
const metaStore = useMetaStore();

const isPreset = ref(false);

const isRTL = computed(() => metaStore.appDirection === AppDirection.RTL);

const lowerBound = 0;
const upperBound = 50;

const price = computed(() => [prStore.filters.price.min ?? lowerBound, prStore.filters.price.max ?? upperBound]);

const presets = [
	{ min: 0, max: 1, label: 'WEBAPP_PRICEFILTER_UPTO', value: 1 },
	{ min: 0, max: 2, label: 'WEBAPP_PRICEFILTER_UPTO', value: 2 },
	{ min: 0, max: 3, label: 'WEBAPP_PRICEFILTER_UPTO', value: 3 },
	{ min: 0, max: 5, label: 'WEBAPP_PRICEFILTER_UPTO', value: 5 },
	{ min: 5, max: null, label: 'WEBAPP_PRICEFILTER_MORETHAN', value: 5 },
];

function isPriceFilterActive(min: number, max: number | null) {
	return min === prStore.filters.price.min && max === prStore.filters.price.max;
}

function setPreset({ min, max }: (typeof presets)[number]) {
	isPriceFilterActive(min, max) ? changePrice([null, null], false) : changePrice([min, max], true);
}

function getPriceLabel(price: number) {
	return isRTL ? price + tc('WEBAPP_STANDARD_CURRENCY') : tc('WEBAPP_STANDARD_CURRENCY') + price;
}

function changePrice([min, max]: [number | null, number | null], preset: boolean) {
	isPreset.value = preset;

	prStore.filters.price.min = min;
	prStore.filters.price.max = max;
}

return { __sfc: true,tc, prStore, metaStore, isPreset, isRTL, lowerBound, upperBound, price, presets, isPriceFilterActive, setPreset, getPriceLabel, changePrice, RangeInput, ToggleButton }
}

})